import React, { useState, useEffect } from 'react';
import { Modal, Button, Input, Row, Col } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const TextEditor = ({
    isOpen,
    onClose,
    initialText,
    onSave,
    placeholder = "Enter image name...",
    rows = 6,
    loader = false,
    isVideo = false,
}) => {
    const [editedText, setEditedText] = useState('');

    useEffect(() => {
        if (isOpen && initialText) {
            setEditedText(initialText);
        }
    }, [isOpen, initialText]);

    const handleSave = () => {
        if (onSave) {
            onSave(editedText);
        }
    };

    const handleCancel = () => {
        setEditedText(initialText || '');
        onClose();
    };

    const handleTextChange = (e) => {
        setEditedText(e.target.value);
    };

    return (
        <Modal
            title={<span className="manrope f-20 lh-28 w-500 black-085 justify-in-start">
                Edit Name
            </span>}
            visible={isOpen}
            onCancel={handleCancel}
            footer={[
                <Button className='manrope f-14 w-500 lh-22 ai-action-btn pd-small' onClick={handleCancel}>
                    Cancel
                </Button>,
                <Button disabled={loader} className='manrope f-14 w-500 lh-22 ai-action-btn-blue pd-small' onClick={handleSave}>
                    {loader ? <span> Saving <LoadingOutlined spin /></span> : "Save Changes"}
                </Button>
            ]}
            closable={true}
            width={600}
            centered
        >
            <Row>
                <Col span={24} className='direction-flex col j-start-a-start'>
                    <h3 className='manrope f-14 w-700 lh-22 black-085'>{isVideo ? "Video Name" : "Image Name"}</h3>

                    <Input.TextArea
                        className='manrope f-14 w-400 lh-22 black-085 w-100'
                        value={editedText}
                        onChange={handleTextChange}
                        placeholder={placeholder}
                        rows={rows}
                        showCount
                    />
                </Col>
            </Row>
        </Modal>
    );
};

export default TextEditor;
